import { LogQueryModel } from './logsquery.model';
export class QueryDefRequest {
  public queryDef: LogQueryModel;

  constructor(logQueryModel: LogQueryModel) {
    this.queryDef = logQueryModel;
  }
}
